import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { SchedulerFrame } from './SignupBookCallView.styles';

type Props = {
  /** Null while the controller is on its way out: without a link to frame there is no call to offer. */
  embedUrl: string | null;
  /** Whether the scheduler has said the call is booked. Only some of them say it, so this only ever adds. */
  booked: boolean;
  onDone: () => void;
};

export const SignupBookCallView: React.FC<Props> = ({ embedUrl, booked, onDone }) => {
  if (embedUrl == null) {
    return null;
  }

  return (
    // The frame takes exactly the height left over, and a floor under it is what puts a second scrollbar on
    // the screen: the page starts scrolling as well as the scheduler inside it.
    <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
      <Typography variant="h4" fontWeight="fontWeightSemiBold" gutterBottom>
        Book your onboarding call
      </Typography>
      {/* Nothing about booking later: this is the only place the link is offered, and there is no way back. */}
      <Typography variant="body1" color="text.secondary" mb={2}>
        Your account is ready. Pick a time and we will walk you through setting up your first campaign.
      </Typography>

      <SchedulerFrame title="Book your onboarding call" src={embedUrl} />

      {/* Below the calendar, where the flex column keeps it on screen rather than under the fold. */}
      {booked && (
        <Box mt={3} mb={2} display="flex" justifyContent="flex-end">
          <Button variant="contained" size="large" onClick={onDone}>
            Continue to your account
          </Button>
        </Box>
      )}
    </Box>
  );
};
